import { useParams, useLocation } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";
import { Cta } from "@/components/Cta";

export function Shop() {
  const { products, wish } = useStore();
  const saved = useLocation().pathname === "/wishlist";
  const list = saved ? products.filter((p) => wish.includes(p.id)) : products;
  return (
    <main className="container-rh py-12 lg:py-20" data-testid={saved ? "wishlist-page" : "shop-page"}>
      <p className="eyebrow text-berry mb-4">{saved ? "Saved for later" : `${products.length} pieces`}</p>
      <h1 className="font-display font-medium text-[48px] sm:text-[64px] leading-none mb-12 lg:mb-16">{saved ? "Your wishlist" : "The Edit"}</h1>
      {list.length === 0 ? (
        <div className="py-16"><p className="text-[18px] text-plum/70 mb-8">Tap the heart on any piece to keep it here.</p><Cta to="/shop" label="See all pieces" /></div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {list.map((p, i) => <Reveal key={p.id} delay={i * 0.08}><ProductCard p={p} index={products.indexOf(p)} /></Reveal>)}
        </div>
      )}
    </main>
  );
}

const TITLES = { shipping: "Shipping", returns: "Returns", privacy: "Privacy", terms: "Terms", care: "Jewellery care" };

export function Policy({ contact }) {
  const { key } = useParams();
  const { site } = useStore();
  const k = contact ? "contact" : key;
  const c = site.contact;
  return (
    <main className="container-rh py-14 lg:py-24 max-w-[860px]" data-testid={`policy-page-${k}`}>
      <p className="eyebrow text-berry mb-4">RATNAHARA</p>
      <h1 className="font-display font-medium text-[48px] sm:text-[60px] leading-none mb-10">{contact ? "Contact us" : TITLES[k] || "Information"}</h1>
      <div className="rounded-[22px] bg-ivory border border-plum/10 p-7 sm:p-10 text-[17px] leading-relaxed whitespace-pre-line">
        {contact ? (
          <div className="space-y-3">
            <p><b>Email:</b> <a className="underline" href={`mailto:${c.email}`}>{c.email}</a></p>
            <p><b>Phone:</b> <a className="underline" href={`tel:${c.phone.replace(/\s/g, "")}`}>{c.phone}</a></p>
            {c.whatsapp && <p><b>WhatsApp:</b> <a className="underline" href={`https://wa.me/${c.whatsapp.replace(/\D/g, "")}`}>{c.whatsapp}</a></p>}
            <p><b>Address:</b> {c.address}</p>
          </div>
        ) : site.policies[k] || "This page is being updated."}
      </div>
    </main>
  );
}
